export default __webpack_public_path__ + "static/media/information01.07425d7c.jpg";